import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AlertMessage } from 'app/shared/utils/alertMessage';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UserData } from 'app/shared/service/UserService';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class CommonAPIService {
  private apiUrl: string;
  organizationResponse: any;
  assignmentsUIResponse: any;
  subAppPermissionByUserNameResponse: any;
  appsResponse: any;
  gamesUIResponse: any;
  isFirstSetsViewResponse: any;

  constructor(public api: ApiService, private http: HttpClient) {
    this.apiUrl = UserData.backend_url + '/v1';
  }

  getOrganizations(): Observable<any> {
    if (this.organizationResponse) {
      return of(this.organizationResponse);
    } else {
      return this.http.get<any>(this.apiUrl + '/organizations').pipe(
        tap(data => {
          if (data) {
            this.organizationResponse = data;
          }
        }),
        catchError(this.handleError<any>('getOrganizations'))
      );
    }
  }

  getAssignmentsUI(): Observable<any> {
    console.log("assign valuesssss " + this.assignmentsUIResponse);
    if (this.assignmentsUIResponse) {
      return of(this.assignmentsUIResponse);
    } else {
      return this.http.get<any>(this.apiUrl + '/assignmentsUI?assignments=inProgress').pipe(
        tap(data => this.assignmentsUIResponse = data),
        catchError(this.handleError<any>('getAssignmentsUI'))
      );
    }
  }

  getSubAppPermissionByUserName(organizationId: string, userName: string, appCode: string): Observable<any> {

      return this.http.get<any>(this.apiUrl + '/organizations/' + organizationId + '/getSubAppPermissionByUserName?userName=' + userName + '&&appId=' + appCode).pipe(
        tap(data => {
          if (data) {
            this.subAppPermissionByUserNameResponse = data;
          }
        }),
        catchError(this.handleError<any>('getSubAppPermissionByUserName'))
      );
  }

  getApps(organizationId: string): Observable<any> {
    if (this.appsResponse) {
      return of(this.appsResponse);
    } else {
      return this.http.get<any>(this.apiUrl + '/organizations/' + organizationId + '/getApps').pipe(
        tap(data => {
          if (data) {
            this.appsResponse = data;
          }
        }),
        catchError(this.handleError<any>('getApps'))
      );
    }
  }
  getGamesUI(organizationId: string): Observable<any> {
    if (this.gamesUIResponse) {
      return of(this.gamesUIResponse);
    } else {
      return this.http.get<any>(this.apiUrl + '/organizations/' + organizationId + '/gamesUI/').pipe(
        tap(data => {
          if (data) {
            this.gamesUIResponse = data;
          }
        }),
        catchError(this.handleError<any>('getApps'))
      );
    }
  }

  isFirstSetsView(): Observable<any> {
    if (this.isFirstSetsViewResponse) {
      return of(this.isFirstSetsViewResponse);
    } else {
      return this.http.get<any>(this.apiUrl + '/isFirstSetsView').pipe(
        tap(data => {
          if (data) {
            this.isFirstSetsViewResponse = data;
          }
        }),
        catchError(this.handleError<any>('isFirstSetsView'))
      );
    }
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

}
